import React, { FunctionComponent } from "react";
import tesoLogo from "../../images/logo-teso.svg";

const Logo: FunctionComponent = () => {
  return <img src={tesoLogo} />;
};

export default Logo;
